// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mi {
  animation: fadeIn 0.3s ease-in;
  max-width: 900px;
}

.mi-title {
  margin-bottom: 1.5rem;
  font-size: 1.4rem;
  color: #f1f5f9;
}

.mi-error {
  color: #f87171;
  padding: 1rem;
  background: rgba(239, 68, 68, 0.1);
  border-radius: 8px;
}

/* ── Header card ── */
.mi-header-card {
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  margin-bottom: 1.75rem;
  border: 1px solid;
}
.mi-header-gbm {
  background: rgba(16, 185, 129, 0.07);
  border-color: rgba(16, 185, 129, 0.3);
}
.mi-header-lr {
  background: rgba(245, 158, 11, 0.07);
  border-color: rgba(245, 158, 11, 0.3);
}
.mi-header-elo_power {
  background: rgba(239, 68, 68, 0.07);
  border-color: rgba(239, 68, 68, 0.3);
}
.mi-header-label {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
  margin-bottom: 0.3rem;
}
.mi-header-name {
  font-size: 1.15rem;
  font-weight: 700;
  color: #f1f5f9;
  margin-bottom: 0.5rem;
}
.mi-header-meta {
  display: flex;
  gap: 1.25rem;
  flex-wrap: wrap;
  font-size: 0.82rem;
  color: #94a3b8;
}
.mi-header-acc {
  color: #34d399;
  font-weight: 600;
}

/* ── Sections ── */
.mi-section {
  margin-bottom: 2rem;
}
.mi-section-title {
  font-size: 1rem;
  font-weight: 700;
  color: #e2e8f0;
  margin-bottom: 0.75rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid #1e293b;
}
.mi-prose {
  font-size: 0.85rem;
  color: #94a3b8;
  line-height: 1.6;
  margin-bottom: 1rem;
}

/* ── Pipeline ── */
.mi-pipeline {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.mi-pipeline-step {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.85rem 1rem;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 8px;
}
.mi-pipeline-step.mi-pipeline-active {
  background: rgba(59, 130, 246, 0.08);
  border-color: #3b82f6;
}
.mi-pipeline-step.mi-pipeline-missing {
  opacity: 0.45;
}
.mi-pipeline-num {
  width: 28px;
  height: 28px;
  background: #334155;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 700;
  color: #94a3b8;
  flex-shrink: 0;
}
.mi-pipeline-active .mi-pipeline-num {
  background: #3b82f6;
  color: #fff;
}
.mi-pipeline-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: #e2e8f0;
}
.mi-pipeline-desc {
  font-size: 0.78rem;
  color: #64748b;
  margin-top: 2px;
}
.mi-pipeline-badge {
  margin-left: auto;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  background: #334155;
  color: #64748b;
  flex-shrink: 0;
}
.mi-pipeline-active .mi-pipeline-badge {
  background: #1d4ed8;
  color: #93c5fd;
}
.mi-pipeline-arrow {
  text-align: center;
  color: #334155;
  font-size: 1rem;
  line-height: 1.4;
  margin: -2px 0;
}

/* ── Walk-forward table ── */
.mi-table-wrap {
  overflow-x: auto;
}
.mi-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem;
}
.mi-table th {
  text-align: left;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #475569;
  padding: 0.4rem 0.75rem;
  border-bottom: 1px solid #1e293b;
}
.mi-table td {
  padding: 0.45rem 0.75rem;
  border-bottom: 1px solid #0f172a;
  color: #94a3b8;
}
.mi-td-year {
  font-weight: 700;
  color: #cbd5e1 !important;
}
.mi-td-winner {
  color: #4ade80 !important;
  font-weight: 700;
}
.mi-td-dim {
  color: #64748b !important;
}
.mi-td-label {
  color: #475569;
  font-size: 0.75rem;
}
.mi-tr-avg td {
  border-top: 1px solid #334155;
  border-bottom: none;
  font-weight: 700;
  padding-top: 0.6rem;
  color: #e2e8f0 !important;
}
.mi-table-note {
  font-size: 0.75rem;
  color: #475569;
  margin-top: 0.6rem;
  line-height: 1.5;
}

/* ── Feature importance ── */
.mi-importance-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}
.mi-importance-row {
  display: grid;
  grid-template-columns: 220px 1fr 52px;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.8rem;
}
.mi-importance-label {
  color: #94a3b8;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mi-importance-bar-wrap {
  background: #1e293b;
  border-radius: 3px;
  height: 8px;
  overflow: hidden;
}
.mi-importance-bar {
  height: 100%;
  background: linear-gradient(90deg, #3b82f6, #10b981);
  border-radius: 3px;
  transition: width 0.4s;
}
.mi-importance-val {
  font-size: 0.72rem;
  color: #475569;
  font-family: 'Courier New', monospace;
  text-align: right;
}

/* ── Feature categories ── */
.mi-feat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  gap: 0.75rem;
}
.mi-feat-card {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 10px;
  overflow: hidden;
}
.mi-feat-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  background: none;
  border: none;
  cursor: pointer;
  color: #f1f5f9;
  text-align: left;
}
.mi-feat-header:hover {
  background: rgba(255,255,255,0.03);
}
.mi-feat-title {
  font-size: 0.88rem;
  font-weight: 600;
  color: #e2e8f0;
}
.mi-feat-count {
  font-size: 0.72rem;
  color: #60a5fa;
  margin-top: 2px;
}
.mi-feat-chevron {
  font-size: 0.65rem;
  color: #475569;
  flex-shrink: 0;
}
.mi-feat-desc {
  font-size: 0.78rem;
  color: #64748b;
  line-height: 1.5;
  padding: 0 1rem 0.75rem;
}
.mi-feat-list {
  list-style: none;
  padding: 0 1rem 0.85rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  border-top: 1px solid #0f172a;
  padding-top: 0.6rem;
}
.mi-feat-list li {
  font-size: 0.77rem;
  line-height: 1.4;
}
.mi-feat-raw {
  color: #60a5fa;
  font-family: 'Courier New', monospace;
}
.mi-feat-human {
  color: #475569;
}

/* ── Step-by-step explanation ── */
.mi-pipeline-text {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

/* ── Power rating components ── */
.mi-component-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 0.75rem;
  margin-top: 0.5rem;
}
.mi-component-card {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 8px;
  padding: 0.85rem 1rem;
}
.mi-component-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 0.4rem;
}
.mi-component-name {
  font-size: 0.9rem;
  font-weight: 700;
  color: #f1f5f9;
}
.mi-component-weight {
  font-size: 0.72rem;
  color: #f59e0b;
  font-weight: 600;
}
.mi-component-desc {
  font-size: 0.78rem;
  color: #94a3b8;
  line-height: 1.5;
}
.mi-iq-list {
  margin: 0.4rem 0 0 1rem;
  padding: 0;
  list-style: disc;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}
.mi-iq-list li {
  font-size: 0.76rem;
  color: #94a3b8;
}
.mi-step-block {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  padding: 0.85rem 1rem;
  background: #1e293b;
  border: 1px solid #1e293b;
  border-radius: 8px;
}
.mi-step-n {
  width: 24px;
  height: 24px;
  background: #334155;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  color: #94a3b8;
  flex-shrink: 0;
  margin-top: 1px;
}
.mi-step-title {
  font-size: 0.88rem;
  font-weight: 600;
  color: #e2e8f0;
  margin-bottom: 0.3rem;
}
.mi-step-body {
  font-size: 0.82rem;
  color: #94a3b8;
  line-height: 1.55;
}
`, "",{"version":3,"sources":["webpack://./src/components/ModelInfo.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qCAAqC;AACvC;AACA;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".mi {\n  animation: fadeIn 0.3s ease-in;\n  max-width: 900px;\n}\n\n.mi-title {\n  margin-bottom: 1.5rem;\n  font-size: 1.4rem;\n  color: #f1f5f9;\n}\n\n.mi-error {\n  color: #f87171;\n  padding: 1rem;\n  background: rgba(239, 68, 68, 0.1);\n  border-radius: 8px;\n}\n\n/* ── Header card ── */\n.mi-header-card {\n  border-radius: 12px;\n  padding: 1.25rem 1.5rem;\n  margin-bottom: 1.75rem;\n  border: 1px solid;\n}\n.mi-header-gbm {\n  background: rgba(16, 185, 129, 0.07);\n  border-color: rgba(16, 185, 129, 0.3);\n}\n.mi-header-lr {\n  background: rgba(245, 158, 11, 0.07);\n  border-color: rgba(245, 158, 11, 0.3);\n}\n.mi-header-elo_power {\n  background: rgba(239, 68, 68, 0.07);\n  border-color: rgba(239, 68, 68, 0.3);\n}\n.mi-header-label {\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #64748b;\n  margin-bottom: 0.3rem;\n}\n.mi-header-name {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #f1f5f9;\n  margin-bottom: 0.5rem;\n}\n.mi-header-meta {\n  display: flex;\n  gap: 1.25rem;\n  flex-wrap: wrap;\n  font-size: 0.82rem;\n  color: #94a3b8;\n}\n.mi-header-acc {\n  color: #34d399;\n  font-weight: 600;\n}\n\n/* ── Sections ── */\n.mi-section {\n  margin-bottom: 2rem;\n}\n.mi-section-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #e2e8f0;\n  margin-bottom: 0.75rem;\n  padding-bottom: 0.4rem;\n  border-bottom: 1px solid #1e293b;\n}\n.mi-prose {\n  font-size: 0.85rem;\n  color: #94a3b8;\n  line-height: 1.6;\n  margin-bottom: 1rem;\n}\n\n/* ── Pipeline ── */\n.mi-pipeline {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n.mi-pipeline-step {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.85rem 1rem;\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 8px;\n}\n.mi-pipeline-step.mi-pipeline-active {\n  background: rgba(59, 130, 246, 0.08);\n  border-color: #3b82f6;\n}\n.mi-pipeline-step.mi-pipeline-missing {\n  opacity: 0.45;\n}\n.mi-pipeline-num {\n  width: 28px;\n  height: 28px;\n  background: #334155;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: #94a3b8;\n  flex-shrink: 0;\n}\n.mi-pipeline-active .mi-pipeline-num {\n  background: #3b82f6;\n  color: #fff;\n}\n.mi-pipeline-name {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #e2e8f0;\n}\n.mi-pipeline-desc {\n  font-size: 0.78rem;\n  color: #64748b;\n  margin-top: 2px;\n}\n.mi-pipeline-badge {\n  margin-left: auto;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  background: #334155;\n  color: #64748b;\n  flex-shrink: 0;\n}\n.mi-pipeline-active .mi-pipeline-badge {\n  background: #1d4ed8;\n  color: #93c5fd;\n}\n.mi-pipeline-arrow {\n  text-align: center;\n  color: #334155;\n  font-size: 1rem;\n  line-height: 1.4;\n  margin: -2px 0;\n}\n\n/* ── Walk-forward table ── */\n.mi-table-wrap {\n  overflow-x: auto;\n}\n.mi-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.82rem;\n}\n.mi-table th {\n  text-align: left;\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #475569;\n  padding: 0.4rem 0.75rem;\n  border-bottom: 1px solid #1e293b;\n}\n.mi-table td {\n  padding: 0.45rem 0.75rem;\n  border-bottom: 1px solid #0f172a;\n  color: #94a3b8;\n}\n.mi-td-year {\n  font-weight: 700;\n  color: #cbd5e1 !important;\n}\n.mi-td-winner {\n  color: #4ade80 !important;\n  font-weight: 700;\n}\n.mi-td-dim {\n  color: #64748b !important;\n}\n.mi-td-label {\n  color: #475569;\n  font-size: 0.75rem;\n}\n.mi-tr-avg td {\n  border-top: 1px solid #334155;\n  border-bottom: none;\n  font-weight: 700;\n  padding-top: 0.6rem;\n  color: #e2e8f0 !important;\n}\n.mi-table-note {\n  font-size: 0.75rem;\n  color: #475569;\n  margin-top: 0.6rem;\n  line-height: 1.5;\n}\n\n/* ── Feature importance ── */\n.mi-importance-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n.mi-importance-row {\n  display: grid;\n  grid-template-columns: 220px 1fr 52px;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 0.8rem;\n}\n.mi-importance-label {\n  color: #94a3b8;\n  text-align: right;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.mi-importance-bar-wrap {\n  background: #1e293b;\n  border-radius: 3px;\n  height: 8px;\n  overflow: hidden;\n}\n.mi-importance-bar {\n  height: 100%;\n  background: linear-gradient(90deg, #3b82f6, #10b981);\n  border-radius: 3px;\n  transition: width 0.4s;\n}\n.mi-importance-val {\n  font-size: 0.72rem;\n  color: #475569;\n  font-family: 'Courier New', monospace;\n  text-align: right;\n}\n\n/* ── Feature categories ── */\n.mi-feat-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));\n  gap: 0.75rem;\n}\n.mi-feat-card {\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.mi-feat-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.85rem 1rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #f1f5f9;\n  text-align: left;\n}\n.mi-feat-header:hover {\n  background: rgba(255,255,255,0.03);\n}\n.mi-feat-title {\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: #e2e8f0;\n}\n.mi-feat-count {\n  font-size: 0.72rem;\n  color: #60a5fa;\n  margin-top: 2px;\n}\n.mi-feat-chevron {\n  font-size: 0.65rem;\n  color: #475569;\n  flex-shrink: 0;\n}\n.mi-feat-desc {\n  font-size: 0.78rem;\n  color: #64748b;\n  line-height: 1.5;\n  padding: 0 1rem 0.75rem;\n}\n.mi-feat-list {\n  list-style: none;\n  padding: 0 1rem 0.85rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  border-top: 1px solid #0f172a;\n  padding-top: 0.6rem;\n}\n.mi-feat-list li {\n  font-size: 0.77rem;\n  line-height: 1.4;\n}\n.mi-feat-raw {\n  color: #60a5fa;\n  font-family: 'Courier New', monospace;\n}\n.mi-feat-human {\n  color: #475569;\n}\n\n/* ── Step-by-step explanation ── */\n.mi-pipeline-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n/* ── Power rating components ── */\n.mi-component-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 0.75rem;\n  margin-top: 0.5rem;\n}\n.mi-component-card {\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 8px;\n  padding: 0.85rem 1rem;\n}\n.mi-component-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 0.4rem;\n}\n.mi-component-name {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #f1f5f9;\n}\n.mi-component-weight {\n  font-size: 0.72rem;\n  color: #f59e0b;\n  font-weight: 600;\n}\n.mi-component-desc {\n  font-size: 0.78rem;\n  color: #94a3b8;\n  line-height: 1.5;\n}\n.mi-iq-list {\n  margin: 0.4rem 0 0 1rem;\n  padding: 0;\n  list-style: disc;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n.mi-iq-list li {\n  font-size: 0.76rem;\n  color: #94a3b8;\n}\n.mi-step-block {\n  display: flex;\n  gap: 1rem;\n  align-items: flex-start;\n  padding: 0.85rem 1rem;\n  background: #1e293b;\n  border: 1px solid #1e293b;\n  border-radius: 8px;\n}\n.mi-step-n {\n  width: 24px;\n  height: 24px;\n  background: #334155;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #94a3b8;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n.mi-step-title {\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: #e2e8f0;\n  margin-bottom: 0.3rem;\n}\n.mi-step-body {\n  font-size: 0.82rem;\n  color: #94a3b8;\n  line-height: 1.55;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
